import { ValidatorFn, ValidationErrors, FormControl } from '@angular/forms';

export function acceptedFormatsValidator(validFormats: string[]): ValidatorFn {
  return (control: FormControl): InvalidFileFormat =>
    validFormats.every(
      format => !control.value.replace(/^.*\\/, '').endsWith(format)
    )
      ? {
          invalidFileFormat: {
            value: control.value.replace(/^.*\\/, ''),
            message: 'Must be valid format'
          }
        }
      : null;
}

export interface InvalidFileFormat extends ValidationErrors {
  invalidFileFormat: {
    value: string;
    message: string;
  };
}
